import React from 'react';
import { Upload } from '@progress/kendo-react-upload';
import { withRouter } from 'react-router-dom';
import {
  getS3URL,
  uploadToS3,
  listFiles,
  deleteFiles,
  moveFiles,
  deleteFolder,
} from 'actions/s3Manager';
import { connect } from 'react-redux';
import Chip from '@material-ui/core/Chip';
import { bindActionCreators } from 'redux';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import FolderIcon from '@material-ui/icons/Folder';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import DraftIcon from '@material-ui/icons/Code'
import InputBase from '@material-ui/core/InputBase'
import LinearProgress from '@material-ui/core/LinearProgress'
import Checkbox from '@material-ui/core/Checkbox'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { TextField, MenuItem, withStyles } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Select from '@material-ui/core/Select'
import language from 'utils/vast-languagepack'
import { ListView, ListViewFooter } from '@progress/kendo-react-listview'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Avatar from '@material-ui/core/Avatar'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import PublishIcon from '@material-ui/icons/Publish'
import PublicIcon from '@material-ui/icons/Public'
import { themeObj } from 'components/withRoot'
import NotFound from 'components/NotFound'
import CircularProgress from '@material-ui/core/CircularProgress'
import Tooltip from 'components/theme/HelpTooltip.js'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { FileCopy } from '@material-ui/icons'
import { openSnackbar, toggleDialog } from 'actions/view'

const supportedImageTypes = ['png', 'jpg', 'jpeg', 'gif', 'svg']
const getFileName = (file, folder = false) => {
  let paths = file.split('/')
  let offset = folder ? 2 : 1
  return paths[paths.length - offset] ? paths[paths.length - offset] : file
}
const getExtension = fileName => {
  let a = fileName.split('.')
  if (a.length === 1 || (a[0] === '' && a.length === 2)) {
    return ''
  }
  return a.pop().toLowerCase()
}
const humanFileSize = (bytes, si = true, dp = 2) => {
  const thresh = si ? 1000 : 1024

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B'
  }

  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  let u = -1
  const r = 10 ** dp

  do {
    bytes /= thresh
    ++u
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  )

  return bytes.toFixed(dp) + ' ' + units[u]
}
const MyFooter = (count = 0) => {
  return (
    <ListViewFooter
      style={{
        borderColor: themeObj.palette.lightGrey,
        fontSize: 14,
        padding: 8,
      }}
    >
      {count} file{count > 1 ? 's' : ''} in total
    </ListViewFooter>
  )
}
const MyItemRender = props => {
  let item = props.dataItem

  const {
    baseUrl,
    checkFolder,
    checked,
    clickHandler,
    hideCheckBoxes,
    onCopy,
  } = props

  if (!checkFolder || !baseUrl)
    return (
      <div className="row p-2 border-bottom align-middle" style={{ margin: 0 }}>
        {' '}
        <div className="col-6">Miss a required parameter</div>
      </div>
    )
  return getExtension(item.Key) === '' ? null : (
    <ListItem
      button
      style={{ borderBottom: `1px ${themeObj.palette.lightGrey} solid` }}
      key={item.Key}
      onClick={() => {
        const file_url = baseUrl + encodeURIComponent(item.Key)

        clickHandler(file_url)
      }}
    >
      {hideCheckBoxes ? null : (
        <Checkbox
          checked={checked[item.Key] ? true : false}
          onChange={e => {
            checkFolder(item.Key, e)
          }}
          onClick={e => e.stopPropagation()}
          inputProps={{ 'aria-label': 'primary checkbox' }}
        />
      )}
      <Avatar>
        {getExtension(item.Key) === 'pdf' ? (
          <PictureAsPdfIcon />
        ) : (
          <img
            alt="avatar"
            src={baseUrl + item.Key}
            style={{ height: 40, width: 40 }}
          />
        )}
      </Avatar>
      <ListItemText
        primary={<strong>{item.Key}</strong>}
        secondary={`Last Modified: ${new Date(
          item.LastModified,
        ).toLocaleDateString('en-US')} - Size: ${humanFileSize(item.Size)}`}
      />
      <CopyToClipboard
        onCopy={() => {
          onCopy()
        }}
        text={baseUrl + encodeURIComponent(item.Key)}
      >
        <Button size={'large'} color="secondary" style={{ marginTop: 10 }}>
          <FileCopy style={{ marginRight: 5 }} />
          Copy
        </Button>
      </CopyToClipboard>
    </ListItem>
  )
}
export default withRouter(
  connect(
    (state, { match }) => ({
      fileList: state.s3Manager.fileList,
      baseUrl: state.s3Manager.baseUrl,
    }),
    dispatch =>
      bindActionCreators(
        {
          getS3URL,
          uploadToS3,
          listFiles,
          deleteFiles,
          moveFiles,
          deleteFolder,
          openSnackbar,
          toggleDialog,
        },
        dispatch,
      ),
  )(
    withMobileDialog()(
      withStyles(theme => ({
        // ...other styles for the pages
        content: {
          padding: 24,
          [theme.breakpoints.down('sm')]: {
            // padding: maybe something else for 'sm' size,
          },
          [theme.breakpoints.down('xs')]: {
            padding: 0,
          },
        },
      }))(
        class S3Manager extends React.Component {
          constructor(props) {
            super(props)
            let fileParams = ''
            this.state = {
              newFolder: '',
              foldersLoading: true,
              filesLoading: true,
              showList: true,
              checked: {},
              deleteDialog: false,
              deleteConfirmationInputText: '',
              moveFilesDialog: false,
              moveConfirmationInputText: '',
              moveSelectedDestination: '',
              showMoveSelect: true,
              checkAll: false,
              showFolderControl: false,
              showUploadModal: false,
              skip: 20,
              clickedFile: '',
              data: [],
              fileParams,
              copied: false,
            }
          }

          componentDidMount() {
            console.log('Its mounting')
            const initialPath =
              this.props.match &&
              this.props.match.params &&
              this.props.match.params.filePath
                ? this.props.match.params.filePath + '/'
                : ''
            this.props.listFiles(initialPath).then(() =>
              this.setState({
                ...this.state,
                filesLoading: false,
                foldersLoading: false,
              }),
            )
          }
          routerWillLeave(nextState) {
            // return false to block navigation, true to allow
            if (nextState.action === 'POP') {
              this.goBack()
            }
          }
          goBack = () => {
            const { fileList, listFiles } = this.props
            const Prefix = fileList && fileList.Prefix

            let backPath = ''
            if (Prefix) {
              const breadcrumbs = Prefix.split('/')
              if (breadcrumbs.length) {
                breadcrumbs.pop()
                breadcrumbs.pop()
                breadcrumbs.forEach(breadcrumb => {
                  if (breadcrumb) backPath += breadcrumb + '/'
                })
              }
              return listFiles(backPath)
            }
          }
          onCopy = () => {
            this.props.openSnackbar({
              type: 'success',
              message: 'Your file url was successfully copied to clipboard',
            })
          }
          clickFile = clickedFile => {
            this.setState({ ...this.state, clickedFile })
          }

          closeClickedFileDialog = () =>
            this.setState({ ...this.state, clickedFile: '' })

          clickPath = (iterator, collection) => {
            let newPath = ''
            collection.slice(0, iterator + 1).map(breadCrumb => {
              newPath += breadCrumb + '/'
              return 0
            })
            console.log('clickpath newpath:', newPath)
            this.props.listFiles(newPath)
          }
          fileCheckBoxChange = (file, e) => {
            let checked = e.currentTarget ? e.currentTarget.checked : false
            let stateChecked = this.state.checked
            let filesState = this.props.fileList.Contents.reduce(
              (map, file) => {
                if (file.Key.lastIndexOf('/') === file.Key.length - 1)
                  delete map[file.Key]
                else
                  map[file.Key] = {
                    Key: file.Key,
                  }
                return map
              },
              {},
            )
            checked
              ? (stateChecked[file] = { Key: file })
              : delete stateChecked[file]
            this.setState({
              ...this.state,
              checked: stateChecked,
              checkAll:
                Object.keys(stateChecked).length ===
                Object.keys(filesState).length,
            })
          }
          fileCheckBoxAllChange = e => {
            if (!this.state.checkAll === true && this.props.fileList) {
              let checked = this.props.fileList.Contents.reduce((map, file) => {
                if (file.Key.lastIndexOf('/') === file.Key.length - 1)
                  delete map[file.Key]
                else
                  map[file.Key] = {
                    Key: file.Key,
                  }
                return map
              }, {})

              this.setState({
                ...this.state,
                checkAll: true,
                checked,
              })
            } else {
              this.setState({
                ...this.state,
                checkAll: false,
                checked: {},
              })
            }
          }
          onAdd = event => {
            const that = this
            const allUploads = []
            this.setState({ ...this.state, filesLoading: true })
            for (let i = 0; i < event.affectedFiles.length; i++) {
              allUploads.push(
                this.props
                  .uploadToS3(
                    (this.props.fileList ? this.props.fileList.Prefix : '') +
                      event.affectedFiles[i].name,
                    event.affectedFiles[i].getRawFile(),
                  )
                  .then(() => {
                    this.props.listFiles(
                      this.props.fileList ? this.props.fileList.Prefix : '',
                    )
                  }),
              )
            }
            Promise.allSettled(allUploads).then(function () {
              that.setState({
                ...that.state,
                filesLoading: false,
                showUploadModal: false,
              })
            })
          }
          showFolderControlInput = show => {
            this.setState({
              ...this.state,
              showFolderControl: show,
            })
          }
          showUploadModal = show => {
            this.setState({
              ...this.state,
              showUploadModal: show,
            })
          }
          getChecked = filename => {
            return this.state.checked[filename] ? true : false
          }
          onFolderInputKeyUp = event => {
            this.setState({
              ...this.state,
              newFolder: event.target.value,
            })
            if (
              event.keyCode === 13 &&
              !event.target.value.includes('/') &&
              !event.target.value.includes('\\')
            ) {
              if (this.state.newFolder) {
                this.createFolder(this.state.newFolder)
                this.setState({
                  ...this.state,
                  newFolder: '',
                })
                event.target.value = ''
              }
            }
          }
          deleteFilesNow = () => {
            let files = Object.keys(this.state.checked).map((key, i) => {
              return this.state.checked[key]
            })

            if (files.length > 0) {
              this.setState({
                ...this.state,
                filesLoading: true,
              })
              this.props.deleteFiles(files).then(() => {
                this.props
                  .listFiles(
                    this.props.fileList ? this.props.fileList.Prefix : '',
                  )
                  .then(() =>
                    this.setState({
                      ...this.state,
                      filesLoading: false,
                      checked: {},
                      deleteDialog: false,
                      checkAll: false,
                      deleteConfirmationInputText: '',
                    }),
                  )
              })
            } else {
              this.setState({
                ...this.state,
                deleteDialog: false,
                deleteConfirmationInputText: '',
              })
            }
          }
          moveFilesNow = () => {
            if (Object.keys(this.state.checked).length > 0) {
              this.setState({
                ...this.state,
                filesLoading: true,
              })
              let files = Object.keys(this.state.checked).map((key, i) => {
                return this.props.moveFiles(
                  this.state.moveSelectedDestination + getFileName(key),
                  key,
                )
              })

              Promise.all(files).then(() => {
                this.props
                  .listFiles(
                    this.props.fileList ? this.props.fileList.Prefix : '',
                  )
                  .then(() =>
                    this.setState({
                      ...this.state,
                      filesLoading: false,
                      checked: {},
                      checkAll: false,
                      moveFilesDialog: false,
                      moveConfirmationInputText: '',
                      moveSelectedDestination: '',
                      showMoveSelect: true,
                    }),
                  )
              })
            } else {
              this.setState({
                ...this.state,
                moveFilesDialog: false,
                moveConfirmationInputText: '',
                moveSelectedDestination: '',
                showMoveSelect: true,
              })
            }
          }
          clickDeleteFilesButton = show => {
            this.setState({
              ...this.state,
              deleteDialog: show,
            })
          }
          clickMoveFilesButton = show => {
            this.setState({
              ...this.state,
              moveFilesDialog: show,
            })
          }
          clickConfirmDelete = confirmed => {
            if (
              confirmed &&
              this.state.deleteConfirmationInputText.toUpperCase() === 'DELETE'
            ) {
              this.deleteFilesNow()
            } else {
              this.setState({
                ...this.state,
                deleteDialog: false,
                deleteConfirmationInputText: '',
              })
            }
          }
          clickConfirmMove = confirmed => {
            if (
              confirmed &&
              this.state.moveConfirmationInputText.toUpperCase() === 'MOVE'
            ) {
              this.moveFilesNow()
            } else {
              this.setState({
                ...this.state,
                moveFilesDialog: false,
                moveConfirmationInputText: '',
                moveSelectedDestination: '',
                showMoveSelect: true,
              })
            }
          }
          clickChooseNewDestination = () => {
            this.setState({
              ...this.state,
              showMoveSelect: true,
            })
          }
          onDeleteConfirmationInputKeyUp = event => {
            this.setState({
              ...this.state,
              deleteConfirmationInputText: event.target.value,
            })
          }
          onMoveConfirmationInputTextUp = event => {
            this.setState({
              ...this.state,
              moveConfirmationInputText: event.target.value,
            })
          }
          handleMoveDestinationChange = event => {
            const destination = event.target.value
            const that = this
            if (destination === 'GOBACK') {
              this.goBack().then(function () {
                that.setState({
                  ...that.state,

                  showMoveSelect: false,
                })
              })
            } else {
              this.props.listFiles(destination)
              this.setState({
                ...this.state,
                moveSelectedDestination: destination,
                showMoveSelect: false,
              })
            }
          }
          handleMobileFileDestinationChange = event => {
            const destination = event.target.value
            if (destination === 'GOBACK') {
              this.goBack().then(function () {})
            } else {
              this.props.listFiles(destination)
            }
          }
          clickCreateNewFolderButton = () => {
            const that = this
            if (that.state.newFolder) {
              that.setState({
                foldersLoading: true,
              })
              setTimeout(function () {
                that.createFolder(that.state.newFolder)
                that.setState({
                  ...that.state,
                  newFolder: '',
                })
              }, 250)
            }
          }
          createFolder = folderName => {
            return this.props
              .uploadToS3(
                (this.props.fileList ? this.props.fileList.Prefix : '') +
                  folderName +
                  '/',
                'folder',
              )
              .then(() => {
                this.props
                  .listFiles(
                    this.props.fileList ? this.props.fileList.Prefix : '',
                  )
                  .then(() => {
                    this.setState({ ...this.state, foldersLoading: false })
                  })
              })
          }
          scrollHandler = event => {
            const e = event.nativeEvent
            console.log(event)
            // const fileList = this.props.fileList;
            if (
              e.target.scrollTop + 10 >=
              e.target.scrollHeight - e.target.clientHeight
            ) {
              this.setState({ skip: this.state.skip + 6 })
            }
          }
          MyCustomItem = props => {
            return (
              <MyItemRender
                {...props}
                checkFolder={this.fileCheckBoxChange}
                clickHandler={
                  this.props.clickFile ? this.props.clickFile : this.clickFile
                }
                onCopy={this.onCopy}
                hideCheckBoxes={Boolean(this.props.clickFile)}
                style={{ height: 20, fontSize: 14, marginBottom: 0 }}
                checked={this.state.checked}
                baseUrl={this.props.baseUrl}
                create={this.props.create}
              />
            )
          }
          //TODO: [VR-1388] fix zoom
          render() {
            const { fileList, listFiles, fullScreen, baseUrl, deleteFolder } =
              this.props
            const { showMoveSelect, copied } = this.state
            console.log(
              'this.state.moveSelectedDestination',
              this.state.moveSelectedDestination,
            )
            const virtualData = fileList
              ? fileList.Contents
                ? fileList.Contents.slice(0, this.state.skip)
                : []
              : []
            const EmptyFolders = (
              <div>
                <p>{language.s3Manager.organizeFilesPt1}</p>
              </div>
            )
            const folders = fileList
              ? fileList.CommonPrefixes.length
                ? fileList.CommonPrefixes.map(function (folder) {
                    return (
                      <Chip
                        key={folder.Prefix}
                        icon={
                          <FolderIcon
                            style={{ color: themeObj.palette.darkerYellow }}
                          />
                        }
                        label={getFileName(folder.Prefix, true)}
                        onClick={() => {
                          listFiles(folder.Prefix)
                        }}
                        onDelete={() =>
                          deleteFolder(folder.Prefix).then(() => {
                            listFiles(fileList ? fileList.Prefix : '')
                          })
                        }
                        variant="outlined"
                        style={{
                          textAlign: 'left',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          background: themeObj.palette.yellow,
                          color: themeObj.palette.darkerYellow,
                          borderRadius: 20,
                          padding: 20,
                          border: `solid 1px ${themeObj.palette.darkerYellow}`,
                          marginRight: 8,
                          marginBottom: 8,
                        }}
                      />
                    )
                  })
                : EmptyFolders
              : null
            const foldersOptions = fileList
              ? fileList.CommonPrefixes
                ? fileList.CommonPrefixes.map(function (folder) {
                    return (
                      <MenuItem key={folder.Prefix} value={folder.Prefix}>
                        <FolderIcon /> {folder.Prefix}
                      </MenuItem>
                    )
                  })
                : null
              : null

            const path = fileList
              ? fileList.Prefix
                ? fileList.Prefix.split('/').map(
                    (breadCrumb, i, collection) => {
                      if (breadCrumb !== '')
                        return (
                          <span
                            key={breadCrumb}
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.clickPath(i, collection)}
                          >
                            {breadCrumb} /{' '}
                          </span>
                        )
                      else return null
                    },
                  )
                : null
              : null
            const Prefix = fileList && fileList.Prefix
            console.log('PREFIX', Prefix)
            const show404 =
              Prefix !== '' &&
              fileList &&
              !Boolean(fileList.Contents.find(obj => obj.Key === Prefix))
            return show404 ? (
              <NotFound />
            ) : (
              <div
                className={this.props.classes.content}
                style={{
                  width: fullScreen ? '100%' : '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Dialog
                  open={this.state.showUploadModal}
                  aria-labelledby="responsive-dialog-title"
                  style={{ borderRadius: 22 }}
                >
                  <DialogContent>
                    <div>
                      <h2>Upload your files</h2>
                      <Upload
                        batch={false}
                        multiple={true}
                        restrictions={{
                          allowedExtensions: [
                            '.jpg',
                            '.png',
                            '.gif',
                            '.tif',
                            '.svg',
                          ],
                        }}
                        onAdd={this.onAdd}
                        withCredentials={false}
                        autoUpload={false}
                      />

                      <h3
                        style={{
                          textAlign: 'middle',
                          position: 'relative',
                          height: 30,
                        }}
                      >
                        <PublicIcon style={{ position: 'absolute', top: 5 }} />
                        <div style={{ left: 30, position: 'absolute', top: 5 }}>
                          {' '}
                          These files are publicly accessible.
                        </div>
                      </h3>
                      <div>
                        <em>
                          Files in Vast Reach are meant for public attachments,
                          public logos and public email images. Do{' '}
                          <strong>not</strong> upload any sensitive information
                          to vast reach
                        </em>
                      </div>
                    </div>
                  </DialogContent>
                  <DialogActions>
                    {this.state.filesLoading ? (
                      <CircularProgress color="secondary" />
                    ) : null}
                    <Button
                      onClick={() => {
                        this.showUploadModal(false)
                      }}
                      color="secondary"
                    >
                      close
                    </Button>
                  </DialogActions>
                </Dialog>
                <Dialog
                  fullScreen={fullScreen}
                  open={this.state.showFolderControl}
                  aria-labelledby="responsive-dialog-title"
                  style={{ borderRadius: 22 }}
                >
                  <DialogContent>
                    <div>
                      <h2>{language.s3Manager.typeFolderName}</h2>
                      <div
                        style={{
                          border: `solid 2px ${themeObj.palette.darkerYellow}`,
                          borderRadius: 28,
                          padding: '0px 6px 0px 6px',
                          margin: 0,
                          position: 'relative',
                          height: 56,
                        }}
                      >
                        <CreateNewFolderIcon
                          style={{
                            fontSize: 26,
                            position: 'absolute',
                            top: 12,
                            left: 8,
                            marginRight: 8,
                            color: themeObj.palette.darkerYellow,
                          }}
                        />
                        <InputBase
                          autoFocus
                          autoComplete={'off'}
                          onKeyUp={this.onFolderInputKeyUp}
                          // onBlur={() => this.showFolderControlInput(false)}
                          style={{
                            fontSize: 20,
                            color: themeObj.palette.black,
                            fontWeight: 'normal',
                            width: '90%',
                            position: 'absolute',
                            top: 8,
                            left: 40,
                          }}
                          placeholder={language.s3Manager.typeFolderName}
                          id="input-with-icon-textfield"
                        />
                      </div>
                      {(this.state.newFolder.includes('/') ||
                        this.state.newFolder.includes('\\')) && (
                        <em>
                          Folder names cannot contain <strong>'/'</strong>{' '}
                          characters
                        </em>
                      )}
                    </div>
                  </DialogContent>
                  <DialogActions>
                    {this.state.foldersLoading ? (
                      <CircularProgress color="secondary" />
                    ) : null}
                    <Button
                      onClick={() => {
                        this.showFolderControlInput(false)
                      }}
                      color="secondary"
                    >
                      Close
                    </Button>
                    {this.state.newFolder.trim().length > 0 &&
                    !this.state.newFolder.includes('\\') &&
                    !this.state.newFolder.includes('/') ? (
                      <Button
                        onClick={this.clickCreateNewFolderButton}
                        style={{
                          backgroundColor: themeObj.palette.green,
                          color: 'white',
                        }}
                      >
                        Create Folder
                      </Button>
                    ) : null}
                  </DialogActions>
                </Dialog>
                <Dialog
                  fullScreen={fullScreen}
                  open={Boolean(this.state.clickedFile)}
                  aria-labelledby="responsive-dialog-title"
                  style={{ borderRadius: 22 }}
                >
                  <DialogContent>
                    {supportedImageTypes.includes(
                      getExtension(this.state.clickedFile),
                    ) ? (
                      <img
                        src={this.state.clickedFile}
                        alt={this.state.clickedFile}
                        style={{ width: '100%', bakcgroundColor: '#006fd90' }}
                      />
                    ) : (
                      <div
                        style={{
                          height: 600,
                          padding: 60,
                          fontSize: 100,
                          textAlign: 'center',
                          paddingTop: '20%',
                        }}
                      >
                        {getExtension(this.state.clickedFile)}
                      </div>
                    )}
                    <span>{this.state.clickedFile}</span>
                    {copied ? (
                      <strong style={{ color: 'green' }}>
                        The file location has been copied to your clipboard!
                      </strong>
                    ) : null}
                  </DialogContent>
                  <DialogActions>
                    <Button
                      autoFocus
                      onClick={() => {
                        this.closeClickedFileDialog()
                        this.setState({
                          copied: false,
                        })
                      }}
                      color="secondary"
                    >
                      close
                    </Button>
                  </DialogActions>
                </Dialog>

                <Dialog
                  fullScreen={fullScreen}
                  open={this.state.deleteDialog === true}
                  aria-labelledby="responsive-dialog-title"
                  style={{ borderRadius: 22 }}
                >
                  <DialogTitle id="responsive-dialog-title">
                    {language.s3Manager.deleteWarning}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      <span>
                        {Object.keys(this.state.checked).map(key => (
                          <Chip style={{ margin: 4 }} key={key} label={key} />
                        ))}
                      </span>
                    </DialogContentText>
                  </DialogContent>
                  <div style={{ width: '100%', padding: 16 }}>
                    <TextField
                      variant="outlined"
                      onKeyUp={e => {
                        this.onDeleteConfirmationInputKeyUp(e)
                      }}
                      style={{ width: '100%' }}
                      helperText={language.s3Manager.deleteConfirmText}
                    />
                  </div>
                  <DialogActions>
                    <Button
                      autoFocus
                      onClick={() => {
                        this.clickConfirmDelete(false)
                      }}
                      color="secondary"
                    >
                      {language.s3Manager.neverMind}
                    </Button>
                    <Button
                      onClick={() => {
                        this.clickConfirmDelete(true)
                      }}
                      color="primary"
                      disabled={
                        this.state.deleteConfirmationInputText.toUpperCase() !==
                        'DELETE'
                      }
                      autoFocus={
                        this.state.deleteConfirmationInputText.toUpperCase() !==
                        'DELETE'
                      }
                    >
                      {language.s3Manager.confirm}
                    </Button>
                  </DialogActions>
                </Dialog>
                <Dialog
                  fullScreen={false}
                  open={this.state.moveFilesDialog === true}
                  aria-labelledby="responsive-dialog-title"
                  style={{ borderRadius: 22 }}
                >
                  <DialogTitle id="responsive-dialog-title">
                    {language.s3Manager.moveWarning}:
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      <span>
                        {Object.keys(this.state.checked).map(key => (
                          <Chip style={{ margin: 4 }} key={key} label={key} />
                        ))}
                      </span>
                    </DialogContentText>
                  </DialogContent>

                  <div
                    style={{ width: '100%', padding: '12px 24px 24px 24px' }}
                  >
                    {showMoveSelect ? (
                      <div>
                        <div
                          style={{
                            fontSize: '1rem',
                            fontWeight: 500,
                            color: themeObj.palette.black,
                          }}
                        >
                          {language.s3Manager.chooseDestination}
                        </div>
                        <Select
                          value={this.state.moveSelectedDestination}
                          onChange={this.handleMoveDestinationChange}
                          style={{ width: '100%', marginBottom: 8 }}
                        >
                          {Prefix && (
                            <MenuItem key={'1234123'} value={'GOBACK'}>
                              <ArrowUpwardIcon />
                              Navigate up one folder
                            </MenuItem>
                          )}
                          {foldersOptions}
                        </Select>
                      </div>
                    ) : (
                      <div>
                        <p
                          style={{
                            border: `1px solid ${themeObj.palette.darkerYellow}`,
                            padding: '12px 16px',
                            borderRadius: 36,
                            margin: 4,
                            background: themeObj.palette.yellow,
                            color: themeObj.palette.darkerYellow,
                          }}
                        >
                          <span style={{ fontSize: '0.8rem' }}>
                            You are <strong>moving</strong> the files above to
                            the following folder:{' '}
                          </span>
                          <br />

                          <Button
                            syle={{ color: themeObj.palette.darkerYellow }}
                          >
                            {' '}
                            <span
                              syle={{
                                fontSize: '0.8rem',
                                color: themeObj.palette.darkerYellow,
                              }}
                              onClick={() => listFiles()}
                            >
                              Home /
                            </span>{' '}
                            {path}
                          </Button>
                        </p>
                        <Button
                          style={{ fontSize: 10, margin: '0 0 8px 8px' }}
                          onClick={this.clickChooseNewDestination}
                        >
                          select a different folder
                        </Button>
                      </div>
                    )}

                    <TextField
                      variant="outlined"
                      onKeyUp={e => {
                        this.onMoveConfirmationInputTextUp(e)
                      }}
                      style={{ width: '100%', marginTop: 16 }}
                      helperText={language.s3Manager.moveConfirmText}
                    />
                  </div>
                  <DialogActions>
                    <Button
                      autoFocus
                      onClick={() => {
                        this.clickConfirmMove(false)
                      }}
                      color="secondary"
                    >
                      {language.s3Manager.neverMind}
                    </Button>
                    <Button
                      onClick={() => {
                        this.clickConfirmMove(true)
                      }}
                      color="primary"
                      disabled={
                        this.state.moveConfirmationInputText.toUpperCase() !==
                        'MOVE'
                      }
                      autoFocus={
                        this.state.moveConfirmationInputText.toUpperCase() ===
                        'MOVE'
                      }
                    >
                      {language.s3Manager.confirm}
                    </Button>
                  </DialogActions>
                </Dialog>
                <h1
                  style={{
                    color: '#014c94',
                    margin: '8px 8px 8px 0',
                  }}
                >
                  <PublicIcon /> PUBLIC FILES{' '}
                  <Tooltip>
                    <span>
                      Public Files is where you can organize your files by using
                      folders. For example you could save your logos under a
                      logo folder and use them when creating forms or emails
                      with a few clicks and navigating to the logo folder.
                    </span>
                  </Tooltip>
                </h1>
                <Grid container>
                  <Grid item xs={12}>
                    <Paper
                      style={{
                        padding: '10px 20px 10px 20px',
                        borderRadius: fullScreen ? 0 : 20,
                        backgroundColor: '#014c94',
                        marginBottom: fullScreen ? 0 : 10,
                        color: 'white',
                      }}
                    >
                      <span
                        style={{ cursor: 'pointer', fontSize: 18 }}
                        onClick={() => listFiles()}
                      >
                        {language.s3Manager.defaultPath}{' '}
                      </span>
                      {path}
                    </Paper>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12}>
                    <Paper
                      style={{
                        width: '100%',
                        padding: fullScreen ? '8px 0px 24px' : '8px 20px 24px',
                        borderRadius: fullScreen ? 0 : 20,
                        textAlign: 'justify',
                      }}
                    >
                      <div style={{ padding: fullScreen ? 8 : 0 }}>
                        <h1 style={{ marginBottom: 12 }}>
                          <div
                            style={{
                              float: 'left',
                              fontSize: 24,
                              marginTop: 0,
                            }}
                          >
                            {language.s3Manager.folderHeader}
                          </div>
                          <div
                            style={{
                              float: 'right',
                              textAlign: 'right',
                              marginTop: -10,
                            }}
                          >
                            <Button
                              title={'create a new folder'}
                              style={{
                                padding: '6px 12px',
                                borderRadius: 28,
                                backgroundColor:
                                  themeObj.palette.secondary.main,
                                marginRight: 8,
                                color: 'white',
                              }}
                              onClick={() => this.showFolderControlInput(true)}
                            >
                              <CreateNewFolderIcon style={{ marginRight: 8 }} />{' '}
                              {language.s3Manager.createNewFolder}
                            </Button>
                          </div>
                          <div style={{ clear: 'both' }}></div>
                        </h1>
                        {this.state.foldersLoading ? (
                          <LinearProgress color="secondary" />
                        ) : null}

                        {fullScreen || this.props.clickFile ? (
                          <Select
                            value={Prefix ? Prefix : 'NONE'}
                            onChange={this.handleMobileFileDestinationChange}
                            style={{ width: '100%', marginBottom: 8 }}
                          >
                            {Prefix && (
                              <MenuItem key={'1234123'} value={'GOBACK'}>
                                <ArrowUpwardIcon />
                                Navigate up one folder
                              </MenuItem>
                            )}
                            {Prefix === '' ? (
                              <MenuItem key={'NONE'} value={'NONE'}>
                                <FolderIcon /> Home
                              </MenuItem>
                            ) : (
                              <MenuItem key={Prefix} value={Prefix}>
                                <FolderIcon /> {Prefix}
                              </MenuItem>
                            )}
                            {foldersOptions}
                          </Select>
                        ) : (
                          <div>{folders}</div>
                        )}
                      </div>

                      <h1
                        style={{
                          marginBottom: 4,
                          marginLeft: fullScreen ? 8 : 0,
                        }}
                      >
                        <div
                          style={{ float: 'left', fontSize: 24, marginTop: 8 }}
                        >
                          {language.s3Manager.filesHeader}

                          {Object.keys(this.state.checked).length ? (
                            <div>
                              <Button
                                onClick={() =>
                                  this.clickDeleteFilesButton(true)
                                }
                              >
                                {language.s3Manager.delete}{' '}
                                {Object.keys(this.state.checked).length}{' '}
                                {language.s3Manager.selectedFiles}
                              </Button>
                              <Button
                                onClick={() => this.clickMoveFilesButton(true)}
                              >
                                {language.s3Manager.move}{' '}
                                {Object.keys(this.state.checked).length}{' '}
                                {language.s3Manager.selectedFiles}
                              </Button>
                            </div>
                          ) : null}
                        </div>
                        <div style={{ float: 'right' }}>
                          <Button
                            onClick={() =>
                              this.props.toggleDialog({
                                open: true,
                                dialog: 'PageEditor',
                              })
                            }
                            style={{
                              padding: '6px 12px',
                              borderRadius: 28,
                              backgroundColor: themeObj.palette.secondary.main,
                              marginRight: 8,
                              color: 'white',
                            }}
                          >
                            <DraftIcon style={{ marginRight: 8 }} />
                            Add page
                          </Button>
                          <Button
                            title={'upload'}
                            style={{
                              padding: '6px 12px',
                              borderRadius: 28,
                              backgroundColor: themeObj.palette.secondary.main,
                              marginRight: 8,
                              color: 'white',
                            }}
                            onClick={() => this.showUploadModal(true)}
                          >
                            <PublishIcon style={{ marginRight: 8 }} /> Upload
                            Files
                          </Button>
                        </div>
                        <div style={{ clear: 'both' }}></div>
                      </h1>
                      {this.state.filesLoading ? (
                        <LinearProgress color="secondary" />
                      ) : null}

                      {fileList &&
                      baseUrl &&
                      fileList.Contents &&
                      ((Prefix && fileList.Contents.length > 1) ||
                        (!Boolean(Prefix) && fileList.Contents.length > 0)) ? (
                        <ListView
                          onScroll={this.scrollHandler}
                          data={virtualData}
                          item={this.MyCustomItem}
                          footer={() =>
                            MyFooter(
                              Prefix
                                ? fileList.Contents.length - 1
                                : fileList.Contents.length,
                            )
                          }
                          style={{ width: '100%', height: 530, border: 'none' }}
                        />
                      ) : (
                        <div style={{ width: '95%', margin: 'auto' }}>
                          <p> {language.s3Manager.noFileDisplay}</p>
                          <Upload
                            batch={false}
                            multiple={true}
                            restrictions={{
                              allowedExtensions: [
                                '.jpg',
                                '.png',
                                '.gif',
                                '.tif',
                                '.svg',
                              ],
                            }}
                            onAdd={this.onAdd}
                            withCredentials={false}
                            autoUpload={false}
                          />
                        </div>
                      )}
                    </Paper>
                  </Grid>
                </Grid>
              </div>
            )
          }
        },
      ),
    ),
  ),
)